import React from 'react';

const Hello = props => (
  <h1>{props.name}!</h1>
)

export default Hello
